// noinspection JSValidateJSDoc
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { has, isNil } from 'lodash-es';
import { SdsPaginator } from '../table-paginator/sds-paginator.lit';
import { SdsTableBase } from '../table/_sds-table-base';
import { ROW } from './_tableTreeConsts';
import styles from './sds-table-tree.lit.scss';
import { TableSubtree } from './table-subtree';
import { sdsCustomElement } from '../utilities/custom-components';
/**
 * Control that represents the list of hierarchical data.
 * This control adds hierarchical controls and paths to given table.
 * For this table must specify the level of each row using `data-level`.
 *
 * Control also supports the rendering of load more button for each level,
 * for this `data-children-count` property together with `data-id`
 * must be specified on a row and if it is greater than the count of **next** siblings
 * with level greater that of this row,
 * load more button is rendered before next row with the level lesser or equal to this one.
 *
 * Control supports aggregated rows. For example a sum of all items of a level.
 * Currently, only `sum` aggregation type is supported. To indicate that the row is an aggregation
 * `data-aggregated-type` must be set to a corresponding aggregation.
 *
 * Row can have children that are not loaded, meaning user wants to load them only after row is expanded,
 * for this `data-lazy` attribute must be set on the row
 *
 * ***Note:** For more examples you can see [the stories](/src/table-tree/sds-table-tree.stories.ts)*
 *
 * @slot - This is where given table is rendered, table must have the description of levels on its rows as described above
 *
 * @fires sds.table-tree.load-more - This event is being fired when load more button is clicked.
 * Event is of `CustomEvent` type with details of `{identifier: string; level: number; loadedCount: number;}` type,
 * where identifier is the value of `data-id` attribute, level is the level of parent row
 * and loadedCount is the count of already loaded children of this row
 *
 * @fires sds.table-tree.expand - This event is being fired when the row being is expanded.
 * Event is of `CustomEvent` type with details of `{identifier: string; level: number;}` type,
 * where identifier is the value of `data-id` attribute and level is the level of expanded row.
 *
 * @fires sds.table-tree.collapse - This event is being fired when the row is collapsed.
 * Event is of `CustomEvent` type with details of `{identifier: string; level: number;}` type,
 * where identifier is the value of `data-id` attribute and level is the level of collapsed row.
 *
 * @deprecated - Use `sds-tree` instead
 */
let SdsTableTree = (() => {
    var _SdsTableTree_expanded_accessor_storage, _SdsTableTree_mode_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-table-tree')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = SdsTableBase;
    let _expanded_decorators;
    let _expanded_initializers = [];
    let _expanded_extraInitializers = [];
    let _mode_decorators;
    let _mode_initializers = [];
    let _mode_extraInitializers = [];
    var SdsTableTree = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsTableTree_expanded_accessor_storage.set(this, __runInitializers(this, _expanded_initializers, false));
            _SdsTableTree_mode_accessor_storage.set(this, (__runInitializers(this, _expanded_extraInitializers), __runInitializers(this, _mode_initializers, 'tree')));
            this._subtrees = __runInitializers(this, _mode_extraInitializers);
            this.childrenObserver = new MutationObserver((mutations) => {
                if (!SdsTableTree.onlyLoadMoreRowsAndNoResultsAreChanged(mutations)) {
                    this.observeChildrenAttributes();
                    void this.onUpdate().then(() => {
                        this.observeTableSizeChange();
                        this.removeLoadMoreRowsOnPaging();
                    });
                }
            });
            this.childrenAttributeObserver = new MutationObserver((mutations) => {
                if (!SdsTableTree.onlyLoadMoreRowsAndNoResultsAreChanged(mutations)) {
                    void this.onUpdate().then(() => {
                        this.removeLoadMoreRowsOnPaging();
                    });
                }
            });
            this.tableSizeChangeObserver = new ResizeObserver(entries => {
                void this.onUpdate();
                // Only disconnect when the table tree width is greater than 0
                if (entries.some(entry => entry.contentRect.width > 0)) {
                    this.tableSizeChangeObserver.disconnect(); // we need this only after first render with width > 0
                }
            });
        }
        static onlyLoadMoreRowsAreChanged(mutations) {
            for (const mutation of mutations) {
                for (const addedNode of mutation.addedNodes) {
                    if (!has(addedNode.dataset, ROW.LOAD_MORE)) {
                        return false;
                    }
                }
                for (const removedNode of mutation.removedNodes) {
                    if (!has(removedNode.dataset, ROW.LOAD_MORE)) {
                        return false;
                    }
                }
            }
            return true;
        }
        static onlyLoadMoreRowsAndNoResultsAreChanged(mutations) {
            for (const mutation of mutations) {
                for (const addedNode of mutation.addedNodes) {
                    if (!has(addedNode.dataset, ROW.LOAD_MORE) &&
                        !has(addedNode.dataset, ROW.NO_RESULTS)) {
                        return false;
                    }
                }
                for (const removedNode of mutation.removedNodes) {
                    if (!has(removedNode.dataset, ROW.LOAD_MORE) &&
                        !has(removedNode.dataset, ROW.NO_RESULTS)) {
                        return false;
                    }
                }
            }
            return true;
        }
        /**
         * True if all rows in this table are expanded
         * @attr
         */
        get expanded() { return __classPrivateFieldGet(this, _SdsTableTree_expanded_accessor_storage, "f"); }
        set expanded(value) { __classPrivateFieldSet(this, _SdsTableTree_expanded_accessor_storage, value, "f"); }
        /**
         * Table mode indicating that this table is used as tree table, meaning it has multiple roots,
         * or as list with only one root.
         * <br>
         *  *Note: Default value is 'tree'*
         * @attr
         */
        get mode() { return __classPrivateFieldGet(this, _SdsTableTree_mode_accessor_storage, "f"); }
        set mode(value) { __classPrivateFieldSet(this, _SdsTableTree_mode_accessor_storage, value, "f"); }
        disconnectedCallback() {
            this.childrenObserver.disconnect();
            this.childrenAttributeObserver.disconnect();
            this.tableSizeChangeObserver.disconnect();
        }
        render() {
            return html ` <slot></slot> `;
        }
        async firstUpdated() {
            await super.firstUpdated();
            return this.onFirstUpdate();
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        getCssText() {
            return SdsTableTree.styles.cssText;
        }
        getCustomClass() {
            return 'sds-table-tree';
        }
        dispatchLoadMore(identifier, level, loadedCount) {
            if (!isNil(identifier)) {
                this.dispatchEvent(new CustomEvent(SdsTableTree.LOAD_MORE_EVENT, {
                    detail: {
                        identifier,
                        level,
                        loadedCount,
                    },
                    bubbles: false,
                    composed: false,
                }));
            }
            else {
                console.error(`load more has no identifier cannot dispatch ${SdsTableTree.LOAD_MORE_EVENT} event`);
            }
        }
        dispatchExpand(identifier, level) {
            this.dispatchEvent(new CustomEvent(SdsTableTree.EXPAND_EVENT, {
                detail: {
                    identifier,
                    level,
                },
                bubbles: false,
                composed: false,
            }));
        }
        dispatchCollapse(identifier, level) {
            this.dispatchEvent(new CustomEvent(SdsTableTree.COLLAPSE_EVENT, {
                detail: {
                    identifier,
                    level,
                },
                bubbles: false,
                composed: false,
            }));
        }
        initRows() {
            this._subtrees = TableSubtree.fromElements(this.querySelectorAll('tbody tr:not([data-load-more]), tr:not([data-no-results])'), (identifier, level, loadedCount) => {
                this.dispatchLoadMore(identifier, level, loadedCount);
            }, (identifier, level) => {
                this.dispatchExpand(identifier, level);
            }, (identifier, level) => {
                this.dispatchCollapse(identifier, level);
            }, this.mode);
            TableSubtree.walkOverSubTrees(this._subtrees, subtree => {
                if (subtree.hasChildren) {
                    subtree.rootNode.addStyleClass(ROW.PARENT);
                }
                if (subtree.rootNode.isChild) {
                    subtree.rootNode.addStyleClass(ROW.CHILD);
                }
            });
        }
        removeLoadMoreRowsOnPaging() {
            const paginator = this.getPaginator();
            if (!isNil(paginator)) {
                const loadMoreRows = this.querySelectorAll('tbody tr[data-load-more]');
                paginator.addEventListener(SdsPaginator.CHANGE_EVENT, () => {
                    loadMoreRows.forEach(row => {
                        row.remove();
                    });
                });
            }
        }
        observeTableChanges() {
            const config = { childList: true, subtree: false }; // we track only immediate descendants
            const tbody = this.querySelector('tbody');
            if (!isNil(tbody)) {
                this.childrenObserver.observe(tbody, config);
                this.observeTableSizeChange();
            }
            else {
                console.error('could not register change observer because no tbody was found');
            }
        }
        observeTableSizeChange() {
            TableSubtree.walkOverSubTrees(this._subtrees, row => {
                this.tableSizeChangeObserver.observe(row.rootNode.innerElement);
            });
        }
        observeChildrenAttributes() {
            const children = this.querySelectorAll('tbody tr');
            const config = {
                childList: false,
                subtree: false,
                attribute: true,
                attributeFilter: ['data-children-count'],
            };
            for (const child of children) {
                this.childrenAttributeObserver.observe(child, config);
            }
        }
        async onFirstUpdate() {
            await this.onUpdate();
            this.observeTableChanges();
        }
        async onUpdate() {
            await this.updateComplete;
            this.querySelectorAll('tr[data-load-more]').forEach(element => element.remove());
            this.querySelectorAll('tr[data-no-results]').forEach(element => element.remove());
            this.initRows();
            this._subtrees.forEach(row => {
                row.addLoadMoreButtonsToSubtree();
                row.addNoDataToSubtree();
                row.addSubtreePathsAndControls();
            });
            if (this.expanded) {
                TableSubtree.walkOverSubTrees(this._subtrees, child => child.expand());
            }
        }
    };
    _SdsTableTree_expanded_accessor_storage = new WeakMap();
    _SdsTableTree_mode_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsTableTree");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _expanded_decorators = [property({ type: Boolean })];
        _mode_decorators = [property({ type: String })];
        __esDecorate(_classThis, null, _expanded_decorators, { kind: "accessor", name: "expanded", static: false, private: false, access: { has: obj => "expanded" in obj, get: obj => obj.expanded, set: (obj, value) => { obj.expanded = value; } }, metadata: _metadata }, _expanded_initializers, _expanded_extraInitializers);
        __esDecorate(_classThis, null, _mode_decorators, { kind: "accessor", name: "mode", static: false, private: false, access: { has: obj => "mode" in obj, get: obj => obj.mode, set: (obj, value) => { obj.mode = value; } }, metadata: _metadata }, _mode_initializers, _mode_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsTableTree = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.LOAD_MORE_EVENT = 'sds.table-tree.load-more';
    _classThis.EXPAND_EVENT = 'sds.table-tree.expand';
    _classThis.COLLAPSE_EVENT = 'sds.table-tree.collapse';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsTableTree = _classThis;
})();
export { SdsTableTree };
